export default "__VITE_ASSET__Bpd9r1EK__"